// src/shared/config/env.js

export const localUrl = 'http://tykven.local/v2';
export const stagingUrl = 'https://staging.app.tykven.com/v2';
export const productionUrl = 'https://client.tykven.com/v2';

export const localPopUrl = 'http://tykven.local/pop/v2/payment/';
export const stagingPopUrl = 'https://staging.app.tykven.com/pop/v2';
export const productionPopUrl = 'https://app.tykven.com/pop/v2';

function getBaseUrl(name) {
  switch (name) {
    case 0: return localUrl;
    case 1: return stagingUrl;
    case 2: return productionUrl;
    default: throw new Error(`Unknown base URL name: ${name}`);
  }
}

function getPopUrl(name) {
  switch (name) {
    case 0: return localPopUrl;
    case 1: return stagingPopUrl;
    case 2: return productionPopUrl;
    default: throw new Error(`Unknown base URL name: ${name}`);
  }
}

export const BASE_URLS = {
    MAIN: getBaseUrl(1),
    POP: getPopUrl(1),
    SECONDARY: process.env.REACT_APP_SECONDARY_API_URL || '',
  };
  
  export const ENV_CONFIG = {
    isDevelopment: process.env.NODE_ENV === 'development',
    isProduction: process.env.NODE_ENV === 'production',
    apiTimeout: 20000,
    devicePlatform: 7, // Web platform identifier
  };
  export default BASE_URLS;


